import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { FlexRow } from 'ui-components/components/flex';
import { noop } from 'ui-components/default-props/noop';

import { emptyArray } from 'ui-components/default-props/empty';
import style from './header.module.less';

const MODE_SELECTOR_ID = 'scan-mode-selector';

export const Header = ({ children = emptyArray, inactive, setScanHeaderFocus = noop }) => {
  const elements = React.Children.toArray(children).map((child) => React.cloneElement(child, { inactive }));

  const onClick = (event) => {
    const {
      target: { id },
    } = event;
    // we do not want to switch focus when you interact with the dropdown
    if (inactive && id !== MODE_SELECTOR_ID) {
      setScanHeaderFocus(false);
    }
  };

  return (
    <FlexRow className={classnames(style['scan-header'], { [style.dark]: inactive })} onClick={onClick}>
      {elements}
    </FlexRow>
  );
};

Header.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
  inactive: PropTypes.bool.isRequired,
  setScanHeaderFocus: PropTypes.func,
};
